import { Paper, styled } from '@mui/material';

export const Root = styled(Paper)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  transform: 'translateX(-50%)',
  pointerEvents: 'none',
});
